import React from 'react';
import IconButton from '../../../core/componentes/comuns/IconButton';

export type ViewMode = 'cards' | 'lista';

export function ViewToggle({ mode, onChange }: { mode: ViewMode; onChange: (m: ViewMode) => void }): JSX.Element {
  return (
    <div className="flex items-center gap-2" role="toolbar" aria-label="Alternância de visualização">
      <IconButton
        aria-pressed={mode === 'cards'}
        srLabel="Visualizar como cards"
        active={mode === 'cards'}
        onClick={() => onChange('cards')}
        title="Cards"
      >
        {/* Grid / Cards icon (simple svg) */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <rect x="3" y="3" width="8" height="8" rx="1" fill="currentColor" />
          <rect x="13" y="3" width="8" height="8" rx="1" fill="currentColor" />
          <rect x="3" y="13" width="8" height="8" rx="1" fill="currentColor" />
          <rect x="13" y="13" width="8" height="8" rx="1" fill="currentColor" />
        </svg>
      </IconButton>

      <IconButton
        aria-pressed={mode === 'lista'}
        srLabel="Visualizar como lista"
        active={mode === 'lista'}
        onClick={() => onChange('lista')}
        title="Lista"
      >
        {/* List icon */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <rect x="4" y="5" width="16" height="2" rx="1" fill="currentColor" />
          <rect x="4" y="11" width="16" height="2" rx="1" fill="currentColor" />
          <rect x="4" y="17" width="16" height="2" rx="1" fill="currentColor" />
        </svg>
      </IconButton>
    </div>
  );
}

export default ViewToggle;
